import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { PropTypes } from "prop-types";
import DishItemText from "./DishItemText";
import forEach from "lodash/forEach";
import { trackEventSegment } from "../utils/segmentUtils";
import { useMutation, useQueryCache } from "react-query";
import { useCookies } from "react-cookie";
import { updateMenuCategoryOrder } from "../api/mutations";
import { useEffect, useState } from "react";
import AddButton from "./AddButton";
import MenuItemForm from "./MenuItemForm";
import findIndex from "lodash/findIndex";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  forEach(result, (item, index) => {
    item["dish_order"] = index + 1;
  });

  return result;
};

const SectionTextList = (props) => {
  const [cookies] = useCookies(["placeId", "menuId"]);

  const cache = useQueryCache();

  const [dishes, setDishes] = useState(props.section.dishes);

  useEffect(() => {
    setDishes(props.section.dishes);
  }, [props.section]);

  const onMutateReorder = (data) => {
    const dishes = data.values.dishes;
    const sectId = data.menuCategoryId;
    cache.cancelQueries("placeDetail");
    const previousPlace = cache.getQueryData(["placeDetail"]);
    const newPlace = Object.assign({}, previousPlace);
    const menuIndex = findIndex(newPlace.menus, ["uuid", props.menuId]);
    const sectIndex = findIndex(newPlace.menus[menuIndex].menu_categories, ["uuid", sectId]);
    newPlace.menus[menuIndex].menu_categories[sectIndex].dishes = dishes;
    cache.setQueryData(["placeDetail"], newPlace);
    return () => cache.setQueryData("placeDetail", previousPlace);
  };

  const [mutate] = useMutation(updateMenuCategoryOrder, { onMutate: onMutateReorder });

  const onDragEnd = (result) => {
    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }
    const items = reorder(dishes, result.source.index, result.destination.index);
    setDishes(items);
    //var destDish = find(dishes, ['dish_order', result.destination.index + 1])
    mutate({
      menuCategoryId: props.section.uuid,
      values: {
        dishes: dishes,
      },
    });
    trackEventSegment("Reordered dishes", {
      subCategoryName: props.section.name,
      subCategoryUuid: props.section.uuid,
    });
  };

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="list">
          {(provided, snapshot) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {dishes.map((item, index) => (
                <Draggable key={item.uuid} draggableId={item.uuid} index={index}>
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                      <DishItemText
                        dish={item.dish}
                        sectionId={props.section.uuid}
                        menuId={props.menuId}
                        numDishes={props.section.dishes.length}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <MenuItemForm
        sectionId={props.section.uuid}
        numOfDishes={props.section.dishes.length}
        menuId={props.menuId}
        hasImageField={false}
        element={<AddButton>Add a new menu item</AddButton>}
      />
    </>
  );
};

SectionTextList.propTypes = {
  section: PropTypes.object.isRequired,
  menuId: PropTypes.string.isRequired,
};

export default SectionTextList;
